Customer.Dashboard ||= {}

class Customer.Dashboard.OperatorStatusView extends Backbone.View
  template: JST["backbone/templates/customer/dashboard/operator_status"]

  events:
    'click .operator_status_item': 'onStatusChange'

  initialize: (options) ->
    @currentStatus = options.current_status

  render: ->
    @setElement(@template(possibleStatuses: Keepcon.operatorStatus))
    @_changeCurrentStatus(@currentStatus)
    setInterval () =>
      @refreshOperatorStatus()
    , Customer.refreshIntervals.operatorStatus
    @

  refreshOperatorStatus: () ->
    $.get('/customer/dashboard/operator_status', (response) =>
      return unless response.operator_status
      if response.success && response.success != 'false'
        if response.operator_status.name != @currentStatus.name
          Backbone.trigger('operator:status:change')
        @_changeCurrentStatus(response.operator_status)
      else
        console.log("Could not refresh operator status (missing permissions?)")
    )

  onStatusChange: (event) =>
    @_keepCustomerSessionAlive()
    previousStatus = @currentStatus
    id = $(event.currentTarget).data('id')
    newStatus = _.find(Keepcon.operatorStatus, (status) -> status.id == id)
    return if previousStatus.id == newStatus.id

    if newStatus.type_as_string == 'Null'
      @_renderSessionExpired()
      return

    @_changeCurrentStatus(newStatus)
    $.post('/customer/dashboard/update_operator_status', { status_id: id }, (response) =>
      if response.success
        if previousStatus.type_as_string == 'Null'
          @_redirectToCustomerTickets()
        else
          Backbone.trigger('operatorStatus:changed', newStatus)
      else
        @_statusChangeFailed(previousStatus, "Status change failed: #{response.message}")
    )

  _changeCurrentStatus: (currentStatus) ->
    @currentStatus = currentStatus
    id = @currentStatus.type_as_string.toLowerCase()
    @$el.attr 'id', id
    $('.operator-status-as-id').attr 'id', id
    @$el.find('.custom-dropdown-toggle .name').text(@currentStatus.name)

  _statusChangeFailed:(previousStatus, message)->
    # set back the previous status because the status change failed
    @_changeCurrentStatus(previousStatus)
    noty({
      text: message,
      type: 'error',
    })

  _renderSessionExpired:()->
    window.location.href = '/customer/dashboard/session_expired'

  _redirectToCustomerTickets:()->
    window.location.href = '/customer/dashboard'

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
